import { useContext } from 'react';
import { FilterStatisticsContext } from 'domains/Statistics/components';

function useStatisticsFiltersContext() {
  return useContext(FilterStatisticsContext);
}

export default useStatisticsFiltersContext;
